import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import NBXUsers from 'services/users.service';

const LocalCurrencyContext = createContext(null);

export const useLocalCurrencyContext = () => useContext(LocalCurrencyContext);

export function LocalCurrencyProvider({ children }) {
  const [localCurrency, setLocalCurrency] = useState(null);

  useEffect(() => {
    NBXStorage.getItem('session').then(
      session =>
        session && NBXUsers.getPreferences().then(preferences => setLocalCurrency(preferences.localCurrency))
    );
  }, []);

  return <LocalCurrencyContext.Provider value={localCurrency}>{children}</LocalCurrencyContext.Provider>;
}

LocalCurrencyProvider.propTypes = {
  children: PropTypes.any.isRequired
};
